import React, { Component } from 'react';
import * as bootstrap from 'bootstrap'
import { bgImageURL } from '../../Global/Constant'
import { CarouselData } from '../../Global/Constant'
class CarouselItems extends Component {
  
  componentDidMount = () => {
    const myCarouselElement = document.querySelector('#carouselExampleIndicators');
    this.interval = setInterval(() => {
      document.getElementsByClassName('carousel-control-next-icon')[0].click();
    }, 5000);
    const carousel = new bootstrap.Carousel(myCarouselElement, {
      wrap: true
    })
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div className="carousel" >
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            {CarouselData.map((item, key) => {
              return <div className={key === 0 ? "carousel-item active" : "carousel-item"} key={key}>
                <a href={bgImageURL} target="_blank" rel="noopener noreferrer">
                  <div className="falseImage" style={{ backgroundImage: `url("${item}")` }}></div>
                </a>
              </div>
            })}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    )
  }
}

export default CarouselItems;